import React from 'react';

import { throttle, get } from 'lodash';

import TopMenu from '../../components/Menu/TopMenu';
import { MENU_ITEMS_ID } from '../../constants';
import { DEFAULT_WINDOWS_TIMEOUT } from '../../../../constants';

// TODO: заведена таска, чтобы переписать компонент TopMenu на функции и якоря: https://tracker.yandex.ru/LT-40376

class TopMenuContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    // по умолчанию активный первый пункт меню
    const active = get(props, ['menuItems', '0', 'id']);

    this.state = {
      active,
    };

    this.handleMenuClick = this.handleMenuClick.bind(this);
    this.handleShowToursClick = this.handleShowToursClick.bind(this);
    this.handleScroll = throttle(
      this.handleScroll,
      DEFAULT_WINDOWS_TIMEOUT / 4,
    ).bind(this);
  }

  componentDidMount() {
    const { menuItems } = this.props;

    window.addEventListener('load', () => {
      this.ELEMENTS = Object.values(menuItems).map(({ id }) =>
        document.getElementById(id),
      );
      this.offset = window.pageYOffset;
      document.addEventListener('scroll', this.handleScroll);
    });
  }

  handleScroll() {
    const { pageYOffset } = window;
    const direction = pageYOffset > this.offset ? 'down' : 'up';
    this.offset = pageYOffset;
    const req =
      pageYOffset + document.body.clientHeight / (direction === 'down' ? 2 : 6);

    const active = this.ELEMENTS.reduce(
      (res, current) => (current.offsetTop <= req ? current.id : res),
      null,
    );

    if (active) {
      this.setState({ active });
    }
  }

  handleMenuClick(id) {
    document.removeEventListener('scroll', this.handleScroll);
    const { scrollToSection } = this.props;
    scrollToSection(id);
    this.setState({ active: id });
    setTimeout(
      () => document.addEventListener('scroll', this.handleScroll),
      DEFAULT_WINDOWS_TIMEOUT,
    );
  }

  handleShowToursClick() {
    this.handleMenuClick(MENU_ITEMS_ID.SEARCHER);
  }

  render() {
    const { active } = this.state;
    return (
      <TopMenu
        {...this.props}
        active={active}
        onMenuItemClicked={this.handleMenuClick}
        onShowToursClicked={this.handleShowToursClick}
      />
    );
  }
}

export default TopMenuContainer;
